"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompilationError = void 0;
class CompilationError extends Error {
}
exports.CompilationError = CompilationError;
//# sourceMappingURL=compilation_error.js.map